import { EButtonEvents } from '@Managers/Events/ButtonEvents';
import EventsCenter from '@Managers/Events/EventsCenter';
import { Button } from '@UILayer/Inputs/Button';
import { DOM_ID } from '@UILayer/UILayer.types';
import cn from 'classnames';
import React, { useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';

// CSS
import styles from '@UILayer/UILayer.scss';

//IMAGES
import soundOff from './icon_sound_off.svg';
import soundOn from './icon_sound_on.svg';

// REDUX
import { getMuteButtonActive, getUnmuteButtonActive } from '@Managers/Redux/AppState/AppState';
import { useAppSelector } from '@Managers/Redux/Hooks';

const SoundButton: React.FC<{}> = () => {
    const [state, setState] = useReducer(
        (state: { isMuteButtonActive: boolean; isUnmuteButtonActive: boolean }, newState: any) => ({ ...state, ...newState }),
        { isMuteButtonActive: false, isUnmuteButtonActive: false }
    );
    const { t } = useTranslation();
    const btnCN = cn(styles.square_btn, styles.standard_btn);
    const gameStoreMuteButtonActive = useAppSelector(getMuteButtonActive);
    const gameStoreUnmuteButtonActive = useAppSelector(getUnmuteButtonActive);

    let id = state.isMuteButtonActive ? DOM_ID.BUTTON_SOUND_FALSE : DOM_ID.BUTTON_SOUND_TRUE;

    useEffect(() => {
        setState({
            isMuteButtonActive: gameStoreMuteButtonActive,
            isUnmuteButtonActive: gameStoreUnmuteButtonActive
        });
    }, [gameStoreMuteButtonActive, gameStoreUnmuteButtonActive]);

    function buttonAction() {
        if (state.isMuteButtonActive) EventsCenter.emit(EButtonEvents.MUTE_BUTTON_PRESSED);
        if (state.isUnmuteButtonActive) EventsCenter.emit(EButtonEvents.UNMUTE_BUTTON_PRESSED);
    }

    return (
        <Button id={id} description={t('WCA_TOGGLE_SOUND_BUTTON')} className={btnCN} onChange={buttonAction}>
            <img src={state.isMuteButtonActive ? soundOn : soundOff} alt={t('WCA_TOGGLE_SOUND_BUTTON')} />
        </Button>
    );
};

export default SoundButton;
